export default "__VITE_ASSET__84338223__"